import React, { useState, useEffect } from "react";
import Sidebar from "./../components/sidebar";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
} from "react-bootstrap";
import {
  FaUserFriends,
  FaGift,
  FaShareAlt,
  FaCheckCircle,
} from "react-icons/fa";
import axios from "axios";

const Recomiendaunamigo = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState({});
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    amigoNombre: "",
    amigoEmail: "",
    producto: "CIRP COMPANY",
    userid: ""
  });

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser');
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
      // Actualizamos el formData con los datos del usuario
      setFormData(prev => ({
        ...prev,
        userid: user.id,
        nombre: user.nombre || prev.nombre,
        email: user.email || prev.email
      }));
    }
  }, []);

  const productos = [
    "CIRP COMPANY",
    "CIRP BUSINESS",
    "CIRP SALES",
    "CIRP TRAINING",
    "CIRP MLM",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const enviarRecomendacion = async (datos) => {
    setLoading(true);
    setError(null);

    try {
      console.log("Datos enviados:", datos);
      await axios.post(
        "https://mrcirp.com/api/enviar_recomendacion.php",
        datos,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSubmitted(true);
    } catch (err) {
      setError(
        err.response?.data?.message || "Error de conexión con el servidor"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    enviarRecomendacion(formData);
  };

  return (
    <Sidebar>
      <Container className="mt-4 mb-5">
        <Row className="mb-4">
          <Col>
            <h1 className="text-center">
              <FaUserFriends className="me-2" />
              Recomienda un amigo
            </h1>
            <p className="text-center text-muted">
              Comparte con tus amigos y obtén beneficios exclusivos
            </p>
          </Col>
        </Row>

        {error && (
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="danger" className="text-center">
                {error}
              </Alert>
            </Col>
          </Row>
        )}

        {submitted ? (
          <Row className="justify-content-center">
            <Col md={8}>
              <Alert variant="success" className="text-center">
                <FaCheckCircle size={24} className="me-2" />
                <h4>¡Recomendación enviada con éxito!</h4>
                <p className="mb-0">
                  Hemos enviado la invitación a tu amigo. Gracias por recomendar
                  nuestros servicios.
                </p>
              </Alert>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col md={6} className="mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <Card.Title className="mb-4">
                    <FaShareAlt className="me-2 text-primary" />
                    Completa el formulario
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <h5 className="mb-3">Tus datos</h5>
                    <Form.Group className="mb-3">
                      <Form.Label>Tu nombre</Form.Label>
                      <Form.Control
                        type="text"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Tu correo electrónico</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <h5 className="mb-3 mt-4">Datos de tu amigo</h5>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre de tu amigo</Form.Label>
                      <Form.Control
                        type="text"
                        name="amigoNombre"
                        value={formData.amigoNombre}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Correo electrónico de tu amigo</Form.Label>
                      <Form.Control
                        type="email"
                        name="amigoEmail"
                        value={formData.amigoEmail}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>Producto a recomendar</Form.Label>
                      <Form.Select
                        name="producto"
                        value={formData.producto}
                        onChange={handleChange}
                        required
                      >
                        {productos.map((producto, index) => (
                          <option key={index} value={producto}>
                            {producto}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={loading}
                    >
                      {loading ? "Enviando..." : "Enviar recomendación"}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="shadow-sm h-100">
                <Card.Body>
                  <Card.Title className="mb-4">
                    <FaGift className="me-2 text-primary" />
                    Beneficios por recomendar
                  </Card.Title>

                  <div className="mb-4">
                    <h5>¿Cómo funciona?</h5>
                    <ol>
                      <li className="mb-2">
                        Completa el formulario con tus datos y los de tu amigo
                      </li>
                      <li className="mb-2">
                        Nosotros le enviaremos una invitación personalizada
                      </li>
                      <li>
                        Cuando tu amigo se registre, ambos recibirán beneficios
                      </li>
                    </ol>
                  </div>

                  <div className="mb-4">
                    <h5>Beneficios</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <FaCheckCircle className="text-success me-2" />
                        Descuento del 25% en tu próxima compra
                      </li>
                      <li className="mb-2">
                        <FaCheckCircle className="text-success me-2" />
                        Acceso a contenido exclusivo
                      </li>
                    </ul>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        <Row className="mt-4">
          <Col>
            <Card className="bg-light">
              <Card.Body className="p-3">
                <p className="small text-muted mb-0">
                  Al recomendar un amigo aceptas nuestros términos y
                  condiciones. Los beneficios se aplicarán una vez tu amigo
                  complete su registro y primera compra. No válido para cuentas
                  existentes. Consulta las bases del programa en nuestra página
                  de términos.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Sidebar>
  );
};

export default Recomiendaunamigo;